import { createContext } from "react";

import type { UseQueryResult } from "@tanstack/react-query";

import type { TreezSpecial } from "../services/discount.service";

export type DiscountsContextValue = {
    discounts: TreezSpecial[];
    isLoading: boolean;
    isFetching: boolean;
    isError: boolean;
    error: UseQueryResult<TreezSpecial[]>["error"] | null;
    refetch: UseQueryResult<TreezSpecial[]>["refetch"];
};

const DiscountsContext = createContext<DiscountsContextValue | null>(null);
DiscountsContext.displayName = "DiscountsContext";

export { DiscountsContext };
